import { render, staticRenderFns } from "./DrugRecord.vue?vue&type=template&id=30116b34&scoped=true"
import script from "./DrugRecord.vue?vue&type=script&lang=js"
export * from "./DrugRecord.vue?vue&type=script&lang=js"
import style0 from "./DrugRecord.vue?vue&type=style&index=0&id=30116b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30116b34",
  null
  
)

export default component.exports